import React from 'react';
import { fetchLawFirmKeywords } from '../lawFirm.api';

type Props = {
  lawOfficeIdGroup: string;
  children: (keywords: Array<string>) => React.ReactNode;
};

type State = {
  keywords: Array<string>;
};

export class LawFirmKeywordsFetcher extends React.Component<Props, State> {
  state: State = {
    keywords: [],
  };

  async componentDidMount() {
    const { keywords } = (
      await fetchLawFirmKeywords(this.props.lawOfficeIdGroup)
    ).data;
    this.setState({ keywords });
  }

  render() {
    return this.props.children(this.state.keywords);
  }
}
